export default "__VITE_ASSET__D849WtXU__"